import { render } from "./ResetPasswordPage.vue?vue&type=template&id=0375f1fe&scoped=true&ts=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=ts"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=0375f1fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0375f1fe"]])

export default __exports__